import { useContext, useState } from 'react';
import './EmailLinkSigninPage.scss';
import { Button, TextField } from '@mui/material';
import { AuthContext } from '../../context';
import { Page } from '../../components';

export const EmailLinkSigninPage = () => {
    const { loginWithEmail } = useContext(AuthContext);
    const [email, setEmail] = useState('');
    const [error, setError] = useState(false);

    const handleClick = () => {
        setError(!email);

        if (email) {
            loginWithEmail(email);
        }
    };

    return (
        <Page className="EmailLinkSigninPage">
            <h2>Sign In</h2>
            <TextField 
                id="email"
                label="Email Address"
                variant='standard'
                error={error}
                value={email}
                onChange={e => setEmail(e.target.value)}
            />
            <Button variant='contained' onClick={handleClick}>Send Sign-In Link</Button>
        </Page>
    );
};